import { Button, Text, Heading, Input } from "./..";
import axios from "axios";
import { useState, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "components/Context/AuthContext";

const apiUrl = process.env.REACT_APP_API_URL;

export default function SignInForm({
  //signInMessage = "Sign in to your account to access your profile and private pages.",
  signInMessage = "Sign in to your account",
  signInButtonText = "Sign in",
  resetPasswordText = "Reset password",
  notAMemberText = "Not a member?",
  createAccountButtonText = "Create accout",
  ...props
}) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const { login } = useContext(AuthContext);
  const navigate = useNavigate();
  const emailInputRef = useRef(null);
  const passwordInputRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${apiUrl}/login`, { username, password }); 
      if (response.data.token) {
        login(response.data);
        navigate('/dashboard')
      }
    } catch (err) {
      // Check if error is an Axios error and has a response
      if (err.response) {
        // The request was made, and the server responded with a status code outside the range of 2xx
        console.error("Error response:", err.response);
        console.error("Status code:", err.response.status);
        console.error("Error data:", err.response.data);

        if (err.response.status === 401) {
          //setError("Invalid credentials. Please try again.");
          setError(err.response.data.error);
        } else if (err.response.status === 500) {
          setError("Server error. Please try again later.");
        } else {
          setError(`An error occurred: ${err.response.data.message || "Unknown error"}`);
        }
      } else if (err.request) {
        // The request was made, but no response was received
        console.error("No response received:", err.request);
        setError("Network error. Please check your internet connection and try again.");
      } else {
        // Something happened in setting up the request that triggered an error
        console.error("Error:", err.message);
        setError("An unexpected error occurred. Please try again.");
      }

    }
  };

  const handleClick = () => {
    navigate('/createAccount')
  }
  
  return (
    <div
      {...props}
      className={`${props.className} flex flex-col items-center w-[400px] md:w-full gap-5 px-9 py-12 md:py-5 sm:p-5 bg-gray-900_02`}
    >
      <Heading as="p" className="self-stretch text-center text-[24px] font-medium leading-[140%] text-white-a700 mb-4">
        {signInMessage}
      </Heading>
      <div className="flex flex-col items-center gap-3 self-stretch">
        <form className="flex flex-col gap-3 self-stretch" onSubmit={handleSubmit} >
          <Input value={username} onChange={(e)=>setUsername(e.target.value)} ref={emailInputRef} required
            shape="square" name="Email Field" placeholder={`Email`} className="bg-gray-900 text-white_a700" style={{ backgroundColor: "var(--gray_900)", borderColor: "var(--gray_900_02)", color: "var(--white_a700)"}} />
          <Input value={password} type="password" onChange={(e)=>setPassword(e.target.value)} ref={passwordInputRef} required
            shape="square" name="Password Field" placeholder={`Password`} className="bg-gray-900 text-white_a700" style={{ backgroundColor: "var(--gray_900)", borderColor: "var(--gray_900_02)", color: "var(--white_a700)",margin: '0' }} />
          {error && <p style={{ color: 'red' }}>{error}</p>}
          <Button type="submit" shape="square" className="px-[34px] sm:px-5">
            {signInButtonText}
          </Button>
        </form>
        <a href="/forgetPassword" className="self-start">
          <Heading size="textxs" as="p" className="text-[12px] font-medium text-white-a700">
            {resetPasswordText}
          </Heading>
        </a>
        <Text as="p" className="text-[14px] font-medium text-white-a700">
          {notAMemberText}
        </Text>
        <Button onClick={handleClick} color="indigo_A700" shape="square" className="px-[34px]">
          {createAccountButtonText}
        </Button>
      </div>
    </div>
  );
}